import { Button } from 'components/ui/Button/Button'
import { useEffect, useState } from 'react'

export interface DeliveryTypeFilterProps {
  onSelect: (value: number) => void
  values: number
}

export const DeliveryTypeFilter: React.FC<DeliveryTypeFilterProps> = ({
  values,
  onSelect,
}: DeliveryTypeFilterProps) => {
  const [text, setText] = useState<string>('')

  useEffect(() => {
    switch (values) {
      case 0:
        setText('Сбор')
        break
      case 1:
        setText('Доставка')
        break
      default:
        setText('Тип заказа')
    }
  }, [values])

  const handleOnSubmit = () => {
    let newState = values + 1
    newState %= 2

    onSelect(newState)
  }

  return (
    <>
      <div className="container-filter">
        <Button title={text} outline round handleOnSubmit={handleOnSubmit}></Button>
      </div>
    </>
  )
}
